import { useContext } from "react";
import { PWAContext } from "../utils/PwaAppContext";
import SignIn from "./SignIn";

export default function SignInWrapper(props) {
  const pwaContext = useContext(PWAContext);
  return <SignIn {...props} PWA={pwaContext} />;
}
